module.exports = __webpack_public_path__ + "static/media/title03.5d9a20bc.webp";